import React from "react";
import RecipientPicker from "./RecipientPicker";
import CountrySelector from "../../../components/common/CountrySelector";
import { Field } from "./Fields";
import DictionaryRecordPicker from "./dictionaries/DictionaryRecordPicker";
import OrderDictionarySave from "./dictionaries/OrderDictionarySave";

/** Edycja odbiorcy niezależna od pozostałych pól projektu. */
export default function RecipientSection({
  recipient,
  candidates,
  roles,
  dictionaryChoices = [],
  dictionaryAccess,
  disabled,
  onChange,
  onShowSource,
}) {
  const setRecipient = (field, value) =>
    onChange({ ...recipient, [field]: value });
  return (
    <section className="card premium-panel">
      <h2>2. Odbiorca</h2>
      <DictionaryRecordPicker
        dictionaries={dictionaryChoices.filter(
          (item) => item.target === "recipient",
        )}
        label="Wybierz odbiorcę ze słownika"
        selectLabel="Użyj tego odbiorcy"
        disabled={disabled}
        onSelect={onChange}
      />
      <RecipientPicker
        candidates={candidates}
        recipient={recipient}
        roles={roles}
        onSelect={onChange}
        onShowSource={onShowSource}
      />
      <Field
        label="Nazwa odbiorcy"
        value={recipient.name}
        onChange={(event) => setRecipient("name", event.target.value)}
      />
      <div className="premium-grid">
        <Field
          label="Adres odbiorcy"
          multiline
          value={recipient.address}
          onChange={(event) => setRecipient("address", event.target.value)}
        />
        <div className="premium-field">
          <CountrySelector
            label="Kraj odbiorcy"
            name="premiumRecipientCountry"
            data={recipient.country}
            disabled={disabled}
            onDataChange={(event) =>
              setRecipient("country", event.target.value)
            }
          />
        </div>
      </div>
      {dictionaryAccess && (
        <OrderDictionarySave
          {...dictionaryAccess}
          target="recipient"
          value={recipient}
          disabled={disabled}
          label="Zapisz odbiorcę w słowniku"
        />
      )}
    </section>
  );
}
